var get_internal_slots = {};
export {
  get_internal_slots as __exports
};
